import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { getMapImageUrl } from "../../constants/mapMeta";
import { formatMapName } from "../../constants/maps";

const useStyles = makeStyles({
  root: {
    width: "100%",
    pointer: "none",
    borderRadius: "6px 6px 0 0",
    position: "relative",
    boxShadow: "none !important",
    backgroundColor: "transparent !important",
  },
  media: {
    minHeight: "10rem",
  },
  mapNameStatus: {
    textAlign: "center",
    position: "absolute",
    top: "0.8rem",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "1rem",
    fontWeight: 525,
    color: "#ffffff !important",
    backgroundColor: "rgba(47, 47, 47, 0.80)",
    textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: "0.35rem 1rem",
    borderRadius: "12px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  mapNameStatusText: {
    transition: "all 0.3s ease",
    fontSize: "0.9rem",
  },
});

export default function MapCard({ name, mapId, isLive, statusText }) {
  const classes = useStyles();
  const fallbackSelectionKey = name.toLowerCase().replace(/\s+/g, "_");
  const resolvedMapId = mapId
    || (fallbackSelectionKey.startsWith("de_")
      ? fallbackSelectionKey
      : `de_${fallbackSelectionKey}`);
  const imageUrl = getMapImageUrl(resolvedMapId);
  const displayName = formatMapName(name);

  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.media}
        image={imageUrl || undefined}
        style={{
          backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
          backgroundColor: imageUrl ? "transparent" : "rgba(255, 255, 255, 0.06)",
        }}
        title={displayName}
      />
      <Typography
        gutterBottom
        variant="h5"
        component="h2"
        className={classes.mapNameStatus}
      >
        {displayName} -{" "}
        <span className={classes.mapNameStatusText}>
          {statusText || (isLive ? "live match" : "match finished")}
        </span>
      </Typography>
    </Card>
  );
}
